module.exports = __webpack_public_path__ + "static/media/Empanadapescado.c496537a.jpg";